import * as contentful from 'contentful';

const SPACE_ID = 'r09sdex51c9w';
const ACCESS_TOKEN = '1f0944501eb94470f596ef4a9ba65e34835358b7c3b7514596c288e3ee89eeef';

const client = contentful.createClient({
    space: SPACE_ID,
    accessToken: ACCESS_TOKEN
});

export default client;


// WEBPACK FOOTER //
// ./src/services/contentful.service.js